import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-2v2',
  templateUrl: './2v2.component.html',
})
export class VbGeneral2v2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
